// 3rd party
import { Injectable } from '@angular/core';
import { Http, HttpModule, Headers, Request, RequestOptions, RequestMethod, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

// models
import { StandardCalibration } from './standard-calibration.model';

// services
import { AuthService } from 'app/shared/services/auth/auth.service';

@Injectable()
export class StandardService {

  constructor(
    private authService: AuthService,
    private http: Http
  ) { }

  // Os metodos devem ser colocados em ordem alfabética
  getStandardCalibrations(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string): Observable<Response> {
    currentPage = currentPage || 1;

    return this.http
      .get('standards/calibrations/' + (identifier ? identifier : '') + '?fields=[]' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Promise.reject(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/standards/shared/standard.service.ts